export default "__VITE_ASSET__3e525a73__"